import React from "react";

import { Flex } from "antd";

import { ExperimentPrototypeWorkspace } from "../components/prototype/ExperimentPrototypeWorkspace";
import { useExperimentEditor } from "../hooks/useExperimentEditor";

export const ExperimentPrototypePage: React.FC = () => {
  const { experimentData, saveAndExit, setExperimentData } = useExperimentEditor();

  return (
    <Flex vertical style={{ flex: 1, overflow: "hidden" }}>
      <ExperimentPrototypeWorkspace
        experimentData={experimentData}
        setExperimentData={setExperimentData}
        onSaveAndExit={saveAndExit}
      />
    </Flex>
  );
};

export default ExperimentPrototypePage;
